export { default } from './PrivateLocationMap';
